import { useMutation, useQueryClient } from '@tanstack/react-query'

import { sendQuote } from '@/requests/quotes'
import type { SendQuoteBody } from '@/requests/quotes'

export class AlreadySentError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'AlreadySentError'
  }
}

export function useQuoteEmailMutation(quoteId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (body: SendQuoteBody) => {
      const result = await sendQuote(quoteId, body)
      if (result.error) {
        if (result.status === 409) throw new AlreadySentError(result.error.message)
        throw new Error(result.error.message)
      }
      return result.data!
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['quotes', quoteId] })
    },
  })
}
